import React from 'react';
import PropTypes from 'prop-types';

import ListCard from './ListCard';
import Icon from '../Icon';
import Plus from '../../svg/icons/add.svg';
import FavoriteHeart from '../../svg/icons/favorite_heart.svg';
import { getNumOfVenuesContent, getImageUrl } from '../../utils';

import './ListCardGrid.scss';
import transformListCreatedBy from '../../transformers/transformListCreatedBy';

export default function ListCardGrid({
  isLoading, lists, onListClick, onAddListClick,
}) {
  if (isLoading) {
    return (
      <div className="ListCardGrid">
        <ListCard isLoading />
        <ListCard isLoading />
        <ListCard isLoading />
        <ListCard isLoading />
        <ListCard isLoading />
        <ListCard isLoading />
        <ListCard isLoading />
        <ListCard isLoading />
      </div>
    );
  }

  return (
    <div className="ListCardGrid">
      <ListCard
        isCreateList
        iconComponent={(
          <Icon height="45px" width="45px" name="plus" component={Plus} />
        )}
        onClick={onAddListClick}
      />
      {lists.map((list) => {
        const thumbnail = (list.responsiveImages)
          ? getImageUrl(list.responsiveImages)
          : undefined;

        return (
          <ListCard
            titleText={list.name}
            createdBy={list.createdBy && transformListCreatedBy(list.createdBy)}
            venueCountText={getNumOfVenuesContent(list.count)}
            iconComponent={(!thumbnail) ? (
              <Icon height="70px" width="70px" name="heart" component={FavoriteHeart} />
            ) : (
              <div
                style={{
                  backgroundImage: `url(${thumbnail})`,
                  width: '100%',
                  height: '100%',
                  backgroundSize: 'cover',
                  borderRadius: '10px',
                }}
              />
            )}
            onClick={() => onListClick(list)}
          />
        );
      })}
    </div>
  );
}

ListCardGrid.propTypes = {
  lists: PropTypes.shape(PropTypes.array),
  isLoading: PropTypes.bool,
  onListClick: PropTypes.func,
  onAddListClick: PropTypes.func,
};

ListCardGrid.defaultProps = {
  lists: [],
  isLoading: false,
  onListClick: /* istanbul ignore next */ () => {},
  onAddListClick: /* istanbul ignore next */ () => {},
};
